import { Controller } from "@hotwired/stimulus";
import "slick-carousel";

export default class SlickController extends Controller {

  connect() {
    this.handleBeforeCache = this.destroySlider.bind(this);

    document.addEventListener(
      "turbo:before-cache",
      this.handleBeforeCache
    );

    this.initializeSlider();
  }

  disconnect() {
    document.removeEventListener(
      "turbo:before-cache",
      this.handleBeforeCache
    );

    this.destroySlider();
  }

  initializeSlider() {
    const isInModal = this.element.closest(".modal") !== null;

    if (isInModal) {
      setTimeout(() => {
        initializePostSlider(this.element, 0, isInModal);
      }, 500);
    } else {
      initializePostSlider(this.element, 0, isInModal);
    }

    this.element
      .querySelector(".slick-dots")
      ?.classList.add("post-media-dots");
  }

  destroySlider() {
    if ($(this.element).hasClass("slick-initialized")) {
      $(this.element).slick("unslick");
    }
  }
}

function initializePostSlider(slider, initialSlide = 0, isInModal = false) {
  if (!slider || $(slider).hasClass("slick-initialized")) {
    return;
  }

  $(slider).slick({
    initialSlide,
    infinite: false,
    slidesToShow: isInModal ? 2 : 3,
    slidesToScroll: 1,
    arrows: true,
    centerMode: true,
    centerPadding: "0px",
    prevArrow:
      "<button type=\"button\" class=\"slick-prev post-media-arrow bg-dark border-2 border-solid border-fluorescent w-35px h-35px rounded-circle text-white z-3 cursor-pointer p-0 d-flex align-items-center justify-content-center translate-middle-y p-1\" aria-label=\"Previous post media\"><svg class=\"d-block pe-none flex-shrink-0\" aria-hidden=\"true\" viewBox=\"0 0 24 24\" fill=\"none\"><path d=\"m15 6-6 6 6 6\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg></button>",
    nextArrow:
      "<button type=\"button\" class=\"slick-next post-media-arrow bg-dark border-2 border-solid border-fluorescent w-35px h-35px rounded-circle text-white z-3 cursor-pointer p-0 d-flex align-items-center justify-content-center translate-middle-y p-1\" aria-label=\"Next post media\"><svg class=\"d-block pe-none flex-shrink-0\" aria-hidden=\"true\" viewBox=\"0 0 24 24\" fill=\"none\"><path d=\"m9 6 6 6-6 6\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg></button>",
    dots: true,
    draggable: true,
    swipe: true,
    touchMove: true,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 1700,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}
